<template>
  <Service color="red">
    <template slot="message">
      Ingen tilgang
    </template>
    <template slot="text">
      Au da! Vi kan ikke finne en gyldig lisens for denne brukeren. <br>
      Sjekk at du er logget inn med riktig bruker, eller om du har de riktige tilgangene.
      Gå til <a href="https://www.cappelendammundervisning.no/cdu/mypage/mypage.action#/products">min side</a> på cdu.no
    </template>
  </Service>
</template>

<script>
import Service from './Service'
export default {
  components: {
    Service
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/service/NoAccess.vue